import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const AreaInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Área que lo implementa">
      {getFieldDecorator("area", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el área."
          }
        ],
        initialValue: implementerProfile && implementerProfile.area
      })(
        <Input
          disabled={isBusy}
          id="area"
          name="area"
          placeholder="Área que lo implementa"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
